"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParsedDesc_1 = require("./ParsedDesc");

var ListParser_1 = require("./parsers/ListParser");

var ListDesc =
/*#__PURE__*/
function (_ParsedDesc_1$ParsedD) {
  _inherits(ListDesc, _ParsedDesc_1$ParsedD);

  function ListDesc(members, desc, validators) {
    var _this;

    _classCallCheck(this, ListDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListDesc).call(this, new ListParser_1.ListParser(members), desc, validators));
    _this.members = members;
    return _this;
  }

  _createClass(ListDesc, [{
    key: "validate",
    value: function validate(input, level) {
      //TODO je to spravne, prevadet null na prazdne pole? Neni spis chyba ve zdroj. datech?
      input = input === null || input === undefined ? [] : input;
      return _get(_getPrototypeOf(ListDesc.prototype), "validate", this).call(this, input, level);
    }
  }, {
    key: "withDescription",
    value: function withDescription(descr) {
      return new ListDesc(this.members, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitList(this);
    }
  }]);

  return ListDesc;
}(ParsedDesc_1.ParsedDesc);

exports.ListDesc = ListDesc;